<div  *ngIf="data === 1">
    <div class='loader loader4'>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

<div *ngIf="data === 2" class="text-center">
    <img src="../../../assets/images/Loading/animation_500_kdqe72ts.gif" alt="" class="loadingWidht img-fluid">
</div>

<div *ngIf="data === 4" style="display: flex; align-items: center; justify-content: center; ">
    <mat-spinner></mat-spinner>
</div>
